import { motion } from "framer-motion";
import SceneShell from "../components/SceneShell";

/**
 * Scene 45 — Impact line: not a gimmick. £3-5M arm of the business.
 */

export default function Scene45_NotAGimmick() {
  return (
    <SceneShell variant="ink" align="left" data-testid="scene-not-gimmick">
      <motion.div
        className="absolute inset-0 pointer-events-none"
        animate={{
          background: [
            "radial-gradient(ellipse at 70% 50%, rgba(233,168,32,0.18) 0%, transparent 55%)",
            "radial-gradient(ellipse at 30% 50%, rgba(212,148,10,0.26) 0%, transparent 55%)",
            "radial-gradient(ellipse at 70% 50%, rgba(233,168,32,0.18) 0%, transparent 55%)",
          ],
        }}
        transition={{ duration: 9, repeat: Infinity, ease: "easeInOut" }}
      />

      <div className="relative max-w-[1500px] mx-auto w-full">
        {/* The two strikethrough phrases */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.3 }}
          className="space-y-3 mb-10"
        >
          <Strike text="Not a gimmick product." delay={0.4} />
          <Strike text="Not a side idea." delay={0.9} />
        </motion.div>

        {/* The big positive line */}
        <motion.h2
          initial={{ opacity: 0, y: 24, filter: "blur(8px)" }}
          animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          transition={{ duration: 1.2, delay: 1.5, ease: [0.16, 1, 0.3, 1] }}
          className="kn-display text-4xl sm:text-6xl lg:text-7xl text-white leading-[1.05]"
          data-testid="not-gimmick-headline"
        >
          This is a{" "}
          <span
            style={{
              background:
                "linear-gradient(135deg, #d4940a 0%, #e9a820 50%, #d4940a 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 0 80px rgba(233,168,32,0.40)",
              fontWeight: 900,
            }}
          >
            £3–5M arm
          </span>
          <br />
          <span className="text-white/55">of the business.</span>
        </motion.h2>
      </div>
    </SceneShell>
  );
}

function Strike({ text, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -16 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
      className="flex items-center gap-3"
    >
      <span
        className="text-2xl sm:text-3xl line-through"
        style={{
          color: "rgba(233,168,32,0.85)",
          textDecorationColor: "rgba(233,168,32,0.95)",
          fontWeight: 600,
        }}
      >
        {text}
      </span>
    </motion.div>
  );
}
